



















export default

	name: 'NewsCard'

	props:
		card: Object

	computed:
		date: -> new Date(@card.postDate).toLocaleDateString('en-us',
			year: 'numeric'
			month: 'long'
			day: 'numeric')

